import React, { useState } from 'react';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';
import { Avatar, AvatarsGroup, Popover, Tooltip } from '@mantine/core';

import DeleteChannelModal from './deleteChannelModal';
import useUpdateTaskBoard from '../hooks/useUpdateTaskBoardChannel';

import { ReactComponent as TeamIcon } from 'assets/icons/teamIcon.svg';
import { ReactComponent as DotsMenu } from 'assets/icons/dotsMenu2.svg';
import { ReactComponent as PinIcon } from 'assets/icons/pinIcon.svg';
import { ReactComponent as ProjectIcon } from 'assets/icons/projectsIcon.svg';
import CreateChannel from './createChannel';

export default function ChannelCard({ item }) {
  const [isMenuOpened, setIsMenuOpened] = useState(false);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [teamMemberPopoverOpened, setTeamMemberPopoverOpened] = useState(false);

  const updateTaskBoardMutation = useUpdateTaskBoard(null, false);

  const handleChannelPin = () => {
    setIsMenuOpened(false);
    updateTaskBoardMutation.mutate({
      id: item?.id,
      is_pinned: item?.is_pinned ? false : true,
    });
  };

  return (
    <div className='mr-8 mb-8 '>
      <div className='border border-gray border-opacity-10 rounded-2xl shadow-lg p-4 bg-white select-none'>
        <div className='flex items-center justify-between'>
          <Link
            to={`/app/projects/task-board/${item?.id}?filter=bucket`}
            state={{ name: item?.name }}
          >
            <div className='flex items-center space-x-2 cursor-pointer'>
              <Avatar
                src={''}
                color='red'
                size={52}
                radius='xl'
                classNames={{
                  image: 'border border-primary rounded-full',
                  placeholder: 'border border-primary rounded-full',
                }}
              >
                {item?.name[0].toUpperCase()}
              </Avatar>
              {item?.name.length >= 30 ? (
                <Tooltip
                  label={item?.name}
                  classNames={{
                    body: 'bg-primary p-3',
                  }}
                  radius='md'
                >
                  <p className='text-333333 font-semibold text-lg w-40 truncate'>
                    {item?.name}
                  </p>
                </Tooltip>
              ) : (
                <p className='text-333333 font-semibold text-lg'>
                  {item?.name}
                </p>
              )}
            </div>
          </Link>
          <div className='flex items-center space-x-2'>
            {item?.is_pinned ? <PinIcon /> : null}
            <Popover
              opened={isMenuOpened}
              onClose={() => setIsMenuOpened(false)}
              target={
                <div className='px-1 cursor-pointer'>
                  <DotsMenu
                    className='cursor-pointer px-1 w-4'
                    onClick={() => {
                      setIsMenuOpened(true);
                    }}
                  />
                </div>
              }
              width={150}
              position='bottom-end'
              classNames={{
                dropdown: 'p-0',
              }}
            >
              <div className='-mb-2'>
                <p
                  className='text-gray hover:bg-[#f2f2f2] cursor-pointer py-1 -mt-1 mb-1'
                  onClick={() => {
                    setIsMenuOpened(false);
                    setTimeout(() => {
                      setEditModalOpen(true);
                    }, 100);
                  }}
                >
                  Edit
                </p>
                <p
                  className='text-gray hover:bg-[#f2f2f2] cursor-pointer py-1 -mt-1 mb-1'
                  onClick={() => {
                    setIsMenuOpened(false);
                    setDeleteModalOpen(true);
                  }}
                >
                  Delete
                </p>
                <p
                  className='text-gray hover:bg-[#f2f2f2] cursor-pointer py-1 -mt-1'
                  onClick={() => handleChannelPin()}
                >
                  {item?.is_pinned ? 'Unpin' : 'Pin to top'}
                </p>
              </div>
            </Popover>
          </div>
        </div>
        <div className='flex items-center space-x-2  mt-2'>
          <div>
            <Tooltip
              label='Last modified'
              classNames={{
                body: 'bg-white text-gray2 shadow-tooltip pr-3 z-0',
              }}
              radius='md'
            >
              <div className='flex  items-center pl-4 space-x-4 mt-3'>
                <TeamIcon />
                <p className='text-gray3 text-sm'>
                  {dayjs(item?.updated_date).format('DD MMM YYYY, hh:mm A')}
                </p>
              </div>
            </Tooltip>
            <div className='flex  items-center pl-4 space-x-4 mt-3'>
              <TeamIcon />
              <p className='text-gray3 text-sm'>
                {item?.members?.length === 1
                  ? `${item?.members?.length} member`
                  : `${item?.members?.length} members`}
              </p>
            </div>
          </div>
          <div
            className='pt-3'
            // onClick={() => {
            //   // setSelectedRow(element);
            //   // setTeamMemberPopoverOpened(true);

            // }}
            onMouseEnter={() => {
              setTeamMemberPopoverOpened(true);
            }}
            onMouseLeave={() => {
              setTeamMemberPopoverOpened(false);
            }}
          >
            <AvatarsGroup
              limit={2}
              total={item?.members?.length}
              size={40}
              classNames={{
                truncated: 'bg-FFE8E1',
              }}
            >
              {item?.members?.map((member) => (
                <Avatar
                  src={member?.employee__profile_picture}
                  color={'red'}
                  radius='xl'
                  size={100}
                  key={member?.id}
                  classNames={{
                    image: 'border border-primary rounded-full',
                    placeholder: 'border border-primary rounded-full',
                  }}
                >
                  {member?.employee__user__first_name[0].toUpperCase()}
                </Avatar>
              ))}
            </AvatarsGroup>
          </div>

          <Popover
            opened={teamMemberPopoverOpened}
            onClose={() => setTeamMemberPopoverOpened(false)}
            onMouseEnter={() => {
              setTeamMemberPopoverOpened(true);
            }}
            onMouseLeave={() => {
              setTeamMemberPopoverOpened(false);
            }}
            width={240}
            title='Team Members'
            position='bottom-end'
            placement='center'
            radius='sm'
            classNames={{
              inner: 'py-2 max-h-48 overflow-y-scroll scroller',
              header: 'border-b-0 text-accent font-medium',
              body: 'shadow-four',
            }}
            className='z-0'
          >
            {item?.members?.map((member) => {
              return (
                <div className='flex space-x-2 pb-4'>
                  <Avatar
                    src={member?.employee__profile_picture}
                    color='#EEF3F1'
                    radius='xl'
                    classNames={{
                      placeholder: 'text-xl',
                    }}
                    className='w-10 h-10'
                  >
                    {member?.employee__user__first_name?.substring(0, 1)}
                  </Avatar>
                  <div className='text-xs mt-1'>
                    <p className='text-121212 w-40 truncate'>
                      {member?.employee__user__first_name}
                    </p>
                    <p className='text-868686'>
                      {member?.employee__designation__name}
                    </p>
                  </div>
                </div>
              );
            })}
          </Popover>
        </div>
        {item?.project ? (
          <div className='flex items-center space-x-5  mt-2 pl-4'>
            <ProjectIcon className='w-5 h-5' />
            <Tooltip
              label='project for this channel'
              classNames={{
                body: 'bg-white text-gray2 shadow-tooltip  z-0',
              }}
              radius='md'
            >
              <p className='text-[#707070]  cursor-pointer'>
                {item?.project__title}
              </p>
            </Tooltip>
          </div>
        ) : (
          <div className='h-6'>
            <p className='text-[#707070]  pl-4 mt-2  cursor-pointer'></p>
          </div>
        )}
        <div className='flex items-center mt-5 justify-between'>
          <div className='flex items-center space-x-2'>
            <Avatar
              src={item?.created_by__profile_picture}
              color='red'
              size={50}
              radius='xl'
            >
              {item?.created_by__first_name[0]?.toUpperCase()}
            </Avatar>
            <div>
              <p className='text-gray'>{item?.created_by__first_name}</p>
              <p className='text-gray3 text-sm'>Project head</p>
            </div>
          </div>
          {/* {item?.project && (
            <p className='text-success font-bold text-lg'>{item?.project}</p>
          )} */}
        </div>
      </div>
      <DeleteChannelModal
        isModalOpen={isDeleteModalOpen}
        setIsModalOpen={setDeleteModalOpen}
        taskboardDetails={item}
      />
      {isEditModalOpen && (
        <CreateChannel
          isModalOpen={isEditModalOpen}
          setIsModalOpen={setEditModalOpen}
          taskboardDetails={item}
          name='Edit'
        />
      )}
    </div>
  );
}
